var map = {
	"./BA1.png": 272,
	"./BA2.png": 273,
	"./BA3.png": 274,
	"./BA4.png": 275,
	"./BC1.png": 276,
	"./BC2.png": 277,
	"./BC3.png": 278,
	"./BC4.png": 279,
	"./BH1.png": 280,
	"./BH2.png": 281,
	"./BH3.png": 282,
	"./BH4.png": 283,
	"./BI1.png": 284,
	"./BI2.png": 285,
	"./BI3.png": 286,
	"./BI4.png": 287,
	"./BR1.png": 288,
	"./BR2.png": 289,
	"./BR3.png": 290,
	"./BR4.png": 291,
	"./BS1.png": 292,
	"./BS2.png": 293,
	"./BS3.png": 294,
	"./BS4.png": 295,
	"./BW1.png": 296,
	"./BW2.png": 297,
	"./BW3.png": 298,
	"./BW4.png": 299,
	"./HA1.png": 300,
	"./HA2.png": 301,
	"./HA3.png": 302,
	"./HA4.png": 303,
	"./HC1.png": 304,
	"./HC2.png": 305,
	"./HC3.png": 306,
	"./HC4.png": 307,
	"./HH1.png": 308,
	"./HH2.png": 309,
	"./HH3.png": 310,
	"./HH4.png": 311,
	"./HI1.png": 312,
	"./HI2.png": 313,
	"./HI3.png": 314,
	"./HI4.png": 315,
	"./HR1.png": 316,
	"./HR2.png": 317,
	"./HR3.png": 318,
	"./HR4.png": 319,
	"./HS1.png": 320,
	"./HS2.png": 321,
	"./HS3.png": 322,
	"./HS4.png": 323,
	"./HW1.png": 324,
	"./HW2.png": 325,
	"./HW3.png": 326,
	"./HW4.png": 327,
	"./WA1.jpg": 328,
	"./WA1.png": 329,
	"./WA2.jpg": 330,
	"./WA2.png": 331,
	"./WA3.jpg": 332,
	"./WA3.png": 333,
	"./WA4.jpg": 334,
	"./WA4.png": 335,
	"./WA5.jpg": 336,
	"./WA5.png": 337,
	"./WC1.jpg": 338,
	"./WC1.png": 339,
	"./WC2.jpg": 340,
	"./WC2.png": 341,
	"./WC3.jpg": 342,
	"./WC3.png": 343,
	"./WC4.jpg": 344,
	"./WC4.png": 345,
	"./WC5.jpg": 346,
	"./WC5.png": 347,
	"./WH1.jpg": 348,
	"./WH1.png": 349,
	"./WH2.jpg": 350,
	"./WH2.png": 351,
	"./WH3.jpg": 352,
	"./WH3.png": 353,
	"./WH4.jpg": 354,
	"./WH4.png": 355,
	"./WH5.jpg": 356,
	"./WH5.png": 357,
	"./WI1.jpg": 358,
	"./WI1.png": 359,
	"./WI2.jpg": 360,
	"./WI2.png": 361,
	"./WI3.jpg": 362,
	"./WI3.png": 363,
	"./WI4.jpg": 364,
	"./WI4.png": 365,
	"./WI5.jpg": 366,
	"./WI5.png": 367,
	"./WR1.jpg": 368,
	"./WR1.png": 369,
	"./WR2.jpg": 370,
	"./WR2.png": 371,
	"./WR3.jpg": 372,
	"./WR3.png": 373,
	"./WR4.jpg": 374,
	"./WR4.png": 375,
	"./WR5.jpg": 376,
	"./WR5.png": 377,
	"./WS1.jpg": 378,
	"./WS1.png": 379,
	"./WS2.jpg": 380,
	"./WS2.png": 381,
	"./WS3.jpg": 382,
	"./WS3.png": 383,
	"./WS4.jpg": 384,
	"./WS4.png": 385,
	"./WS5.jpg": 386,
	"./WS5.png": 387,
	"./WW1.jpg": 388,
	"./WW1.png": 389,
	"./WW2.jpg": 390,
	"./WW2.png": 391,
	"./WW3.jpg": 392,
	"./WW3.png": 393,
	"./WW4.jpg": 394,
	"./WW4.png": 395,
	"./WW5.jpg": 396,
	"./WW5.png": 397
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99;